import src from "IMAGE";
export default { src, width: 768, height: 144, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAIAAADq9gq6AAAAPUlEQVR42gEyAM3/AIdfwL+P3M2B6N2H6eJ55q5+5o1k4d5x4wCbbcTKm+HOg+jeiurieuawgOeKfeTVtOtByyIAMx8a3AAAAABJRU5ErkJggg=="};
